import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { arrayMoveImmutable } from 'array-move';
import { sortableContainer, sortableElement, sortableHandle } from 'react-sortable-hoc';
import Icon from 'common/components/elements/icons';
import { reorderSocialMediaLinks } from 'admin/api/AuthApi';
import ConfirmModal from 'common/components/modules/modal-wrapper';
import {
   HeaderAddAndReorderButton,
} from 'admin/views/site-designer/modules';
import { DotsOptions } from 'admin/views/site-designer/modules';
import {
   SiteDesignFileUpload,
} from 'admin/views/site-designer/modules/sections/modules'
import Input from "common/components/elements/inputs/inputs";
import { isEqual } from 'lodash';
import { useDispatch } from 'react-redux';
import { updateGlobalSettingsCompleted } from 'admin/state/modules/site-designer/actions';
import { useSiteGlobalSettingsHelper } from 'common/designer-modules/globalSettingsHelper';

const Item = ({
   link,
   linkKey,
   mediaLink,
   image,
}) => {
   return (
      <div className='flex gap-3'>
         <div className='w-6 h-6 rounded-full overflow-hidden'>
            {
               !image && (
                  <Icon
                     name='link'
                     size='xl'
                     color='secondary'
                  />
               )
            }
            {
               image && (
                  <img src={ image } alt={ linkKey } className='h-full w-full' />
               )
            }
         </div>

         <span>{link.name}</span>
         {
            mediaLink && (
               <div
                  role='presentation'
                  onClick={ e => {
                  // e.preventDefault();
                     e.stopPropagation()
                  } }
                  className='w-6 h-6 rounded-full overflow-hidden'>
                  <a href={ mediaLink } target='_blank' rel='noreferrer'>
                     <Icon name='go-to' color='action' size='lg' />
                  </a>
               </div>
            )
         }
      </div>
   )
}

const DragHandle = sortableHandle(() => (
   <div className='flex w-5 h-5 items-center drag-cursor'>
      <Icon name='drag'
         darkColor='secondary-dark'
         color='secondary'
         size='xl' />
   </div>
));

const SortableItem = sortableElement(({
   link,
   linkKey,
   image,
}) => {

   return (
      <div className='flex py-2 px-4 bg-grey-main rounded-lg w-ful justify-between'>
         <Item
            link={ link }
            linkKey={ linkKey }
            mediaLink={ null }
            image={ image }
         />
         <DragHandle />
      </div>
   ) });


const SortableContainer = sortableContainer(({ children }) => {
   return <>{children}</>
})


const DEFAULT_CONFIRM_MODAL_STATE = {
   isOpen: false,
   type: null,
   linkItem: {
      name: '',
      link: '',
      image_src: '',
      image_full_src: '',
      is_deleted: false,
      is_visibility: true,
      order: null,
   },
}
const SocialMediaLinks = ({
   value,
   onChange,
}) => {
   const dispatch = useDispatch();
   const { generateSocialMediaLink, getSocialMediaLinkImage } = useSiteGlobalSettingsHelper({ social_media_links: value });
   function sortObjectByValues(obj) {
      if(!obj) return [];
      const object =  Object.fromEntries(
         Object.entries(obj).sort(([, a], [, b]) => a.order - b.order) // Sort by values (ascending)
      );
      return Object.keys(object);
   }

   const [orderKeys, setOrderKeys] = useState(sortObjectByValues(value));

   const [reorderState, setReorderState] = useState({
      isOpen: false,
      disabledDoneButton: false,
      list: [],
      orderedData: [],
   });

   const [confirmModalState, setConfirmModalState] = useState(DEFAULT_CONFIRM_MODAL_STATE);

   const onSortEnd = ({ oldIndex, newIndex }) => {
      const newData = arrayMoveImmutable(reorderState.list, oldIndex, newIndex)
      if(oldIndex !== newIndex){
         const orderedData = newData.map((key, index) => {
            return {
               key,
               order: index + 1,
            };
         });
         setReorderState({
            ...reorderState,
            list: newData,
            orderedData: orderedData,
         });
      }
   }

   const onClickReorder = async () => {
      const orderData = reorderState.orderedData;
      setReorderState({
         ...reorderState,
         disabledDoneButton: true,
      })
      await reorderSocialMediaLinks({ data: reorderState.orderedData });
      let newLinksData = structuredClone(value);
      Object.keys(newLinksData).forEach(key => {
         const orderItem = orderData.find(i => i.key === key);
         const order = orderItem?.order || null;
         newLinksData[key].order = order;
      })
      dispatch(updateGlobalSettingsCompleted('social_media_links', newLinksData, true))
      setOrderKeys(reorderState.list);
      setReorderState({
         isOpen: false,
         list: {},
         orderedData: [],
         disabledDoneButton: false,
      });
   }

   return (
      <div className='flex flex-col gap-2'>
         {
            confirmModalState?.isOpen && (
               <SocialMediaLinksModal
                  type={ confirmModalState.type }
                  linkItem={ confirmModalState.linkItem }
                  linkKey={ confirmModalState.linkKey }
                  onCloseModal={ _ => setConfirmModalState(DEFAULT_CONFIRM_MODAL_STATE) }
                  onChange={ (data) => {
                     setConfirmModalState({
                        ...confirmModalState,
                        linkItem: {
                           ...confirmModalState.linkItem,
                           ...data,
                        },
                     });
                  } }
                  action={ (type) => {
                     let payload = confirmModalState.linkItem;
                     let key = confirmModalState.linkKey;
                     if(!key){
                        let name = confirmModalState?.linkItem?.name || '';
                        name = name.toLocaleLowerCase().replaceAll(' ', '_');
                        key = `social_media_links_${ name }`;
                     }
                     switch (type) {
                        case 'visibility':{
                           payload.is_visibility = !confirmModalState.linkItem.is_visibility;
                           break;
                        }
                        case 'delete':{
                           if(payload.is_custom){
                              payload = {
                                 ...payload,
                                 is_deleted: true,
                              }
                           }
                           if(!payload.is_custom){
                              payload = {
                                 ...payload,
                                 nickname: '',
                              }
                           }
                           break;
                        }
                        case 'revert':{
                           payload = {
                              ...payload,
                              is_deleted: false,
                           }
                           break;
                        }
                        default:
                           break;
                     }
                     onChange(key, payload);
                     setConfirmModalState(DEFAULT_CONFIRM_MODAL_STATE);
                  } }
               />
            )
         }
         <HeaderAddAndReorderButton
            addButtonText='Add new custom link'
            isOpenReorder={ reorderState?.isOpen }
            disabledDoneButton={ reorderState?.disabledDoneButton }
            onClickReorder={ _ => {
               setReorderState({
                  isOpen: true,
                  list: sortObjectByValues(value),
                  orderedData: [],
               })
            } }
            onClickDone={ onClickReorder }
            onClickCancel={ _ => {
               setReorderState({
                  isOpen: false,
                  list: {},
                  orderedData: [],
               })
            } }
            onClickAddNew={ _ => setConfirmModalState({
               isOpen: true,
               type: 'add',
               linkItem: { ...DEFAULT_CONFIRM_MODAL_STATE.linkItem, is_custom: true },
            }) }
         />
         {
            reorderState?.isOpen && (
               <SortableContainer
                  onSortEnd={ onSortEnd }
                  axis='y'
                  useDragHandle
                  helperClass='sortable-helper'
               >
                  <div className='flex flex-col gap-2'>
                     {
                        reorderState.list?.map((key, index) => {
                           const link = value[key]
                           return (
                              <SortableItem
                                 link={ link }
                                 linkKey={ key }
                                 // onSortEnd={ onSortEnd }
                                 index={ index }
                                 key={ key }
                                 shouldUseDragHandle={ true }
                                 image={ getSocialMediaLinkImage(key) }
                              />
                           )
                        })
                     }
                  </div>
               </SortableContainer>
            )
         }
         {
            !reorderState?.isOpen && orderKeys && orderKeys.map((key, index) => {
               const link = value[key]
               let mediaLink = generateSocialMediaLink(key);
               return (
                  <div
                     key={ key }
                     role='presentation'
                     onClick={ _ => {
                        setConfirmModalState({
                           isOpen: true,
                           type: 'edit',
                           linkItem: link,
                           linkKey: key,
                        })
                     } }
                     className={ cx({
                        'flex py-2 px-4 bg-grey-main rounded-lg w-ful justify-between cursor-pointer': true,
                        'border border-error ': Boolean(link.is_custom && link.is_deleted),
                        'hover:bg-hover': !Boolean(link.is_custom && link.is_deleted),
                     }) }
                  >
                     <Item
                        link={ link }
                        linkKey={ key }
                        mediaLink={ mediaLink }
                        image={ getSocialMediaLinkImage(key) }
                     />

                     <div className='flex gap-3'>
                        {
                           !link.is_visibility && (
                              <Icon
                                 name='unpublish'
                                 size='xl'
                                 color='secondary'
                              />
                           )
                        }
                        <DotsOptions
                           options={ [
                              { value: 'edit', title: 'Edit', icon: 'pencil', color: 'secondary', textColor: 'major' },
                              { value: 'views', title: 'Show/Hide', icon: 'pencil', color: 'secondary', textColor: 'major', disabled: !mediaLink, disabledTooltipText: "You haven't added a link to the social media yet" },
                              { value: 'delete', title: 'Delete', icon: 'delete', color: 'error' },
                           ] }
                           tooltipId={ `site_custom_color_${ key }_dots_tootltip` }
                           onClickOptions={ (type) => {
                              setConfirmModalState({
                                 isOpen: true,
                                 type,
                                 linkItem: link,
                                 linkKey: key,
                              })
                              //
                           } }
                           showRevertButton={ Boolean(link.is_custom && link.is_deleted) }
                           onClickRevert={ () => {
                              setConfirmModalState({
                                 isOpen: true,
                                 type: 'revert',
                                 linkItem: link,
                                 linkKey: key,
                              })
                           } }
                        />
                     </div>
                  </div>
               )
            })
         }
      </div>
   )
}

const SocialMediaLinksModal = ({
   type,
   linkItem = {},
   onCloseModal,
   action,
   onChange,
   linkKey,
}) => {
   const { SOCIAL_MEDIAS } = useSiteGlobalSettingsHelper();

   const [isInvalidLink, setIsInvalidLink] = useState(false);
   const initialLinkItemRef = useRef(linkItem);
   const { name, link, image_src, image_full_src, is_visibility, is_custom, nickname } = linkItem;

   const getState = () => {
      let payload = {
         nickname: nickname || '',
      }
      let initialPayload = {
         nickname: initialLinkItemRef?.current?.nickname || '',
      }

      let disabledActionButton = false;
      if(is_custom){
         payload = {
            name: name || '',
            link: link || '',
            image_src: image_src || '',
         }
         initialPayload = {
            name: initialLinkItemRef?.current?.name || '',
            link: initialLinkItemRef?.current?.link || '',
            image_src: initialLinkItemRef?.current?.image_src || '',
         }
         disabledActionButton = !name || isInvalidLink;
      }
      disabledActionButton = disabledActionButton || isEqual(payload, initialPayload)

      const state = {
         add: {
            icon: 'add',
            type: 'action',
            title: 'Add new link',
            buttonText: 'Done',
            disabled: disabledActionButton,
         },
         edit: {
            icon: 'pencil',
            type: 'action',
            title: is_custom ? 'Edit link' : name,
            buttonText: 'Done',
            disabled: disabledActionButton,
         },
         delete: {
            icon: 'delete',
            type: 'confirm',
            title: `Delete ${ name } link?`,
            description: `Are you sure you want to delete ${ name }?`,
            buttonText: 'Yes. delete',
            nonPrimaryColor: true,
            textColor: 'error',
            cancelText: 'Cancel',
            iconColor: 'error',
         },
         visibility: {
            icon: 'unpublish',
            type: 'confirm',
            title: is_visibility ? 'Hide' : 'Show',
            buttonText: 'Yes',
            cancelText: 'Cancel',
         },
         revert: {
            icon: 'revert',
            type: 'confirm',
            title: 'Revert',
            buttonText: 'Yes',
            cancelText: 'Cancel',
         },
      }
      const result = state[type];
      const logo = SOCIAL_MEDIAS?.[linkKey]?.logo;
      if(!is_custom && logo){
         if(result.icon){
            result.icon = null;
         }
         result.imageAsIconSrc = logo;
      }
      return state[type]
   }
   function isValidURL(url) {
      const pattern = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-./?%&=]*)?$/i;
      return pattern.test(url);
   }
   return (
      <ConfirmModal
         { ...getState() }
         contentWidth='375px'
         onCloseModal={ onCloseModal }
         isPreventDeafault={ false }
         action={ () => {
            if(!isValidURL(linkItem?.link) && ['add', 'edit'].includes(type) && is_custom){
               setIsInvalidLink(true);
               return
            }
            action(type);
         } }
      >
         {
            ['add', 'edit'].includes(type) && (
               <div className='flex flex-col w-full gap-7'>
                  {
                     is_custom && (
                        <>
                           <Input
                              name='name'
                              label='Link name'
                              description={ `${ name?.length || 0 } of 25 characters` }
                              placeholder='Enter your link name'
                              value={ name || '' }
                              onChange={ (name, value) => onChange({ [name]: value }) }
                              descriptionPosition='right'
                           />
                           <Input
                              name='link'
                              label='Link'
                              description={ `${ link?.length || 0 } of 25 characters` }
                              placeholder='Enter your link'
                              value={ link || '' }
                              onChange={ (name, value) => {
                                 if(isInvalidLink){
                                    setIsInvalidLink(false);
                                 }
                                 onChange({ [name]: value })
                              } }
                              descriptionPosition='right'
                              errorMessage={ isInvalidLink ? 'Please enter a valid URL' : null }
                              hideDescriptionWhenError
                           />
                           <div className='w-20 h-20'>
                              <SiteDesignFileUpload
                                 onChange={ (image_src = null, image_full_src = null) => {
                                    onChange({
                                       image_src,
                                       image_full_src,
                                    })
                                 } }
                                 src={ image_src }
                                 fullSrc={ image_full_src }
                              />
                           </div>
                        </>
                     )
                  }
                  {
                     !is_custom && (
                        <Input
                           name='nickname'
                           label='Nickname'
                           description={ `${ nickname?.length || 0 } of 25 characters` }
                           placeholder='Enter your link nickname'
                           value={ nickname || '' }
                           onChange={ (nickname, value) => onChange({ [nickname]: value }) }
                           descriptionPosition='right'
                        />
                     )
                  }
               </div>
            )
         }
      </ConfirmModal>
   )
}
SocialMediaLinksModal.propTypes = {
   type: PropTypes.string,
   linkKey: PropTypes.string,
   linkItem: PropTypes.object,
   onCloseModal: PropTypes.func,
   action: PropTypes.func,
   onChange: PropTypes.func,
}
Item.propTypes = {
   link: PropTypes.object,
   linkKey: PropTypes.string,
   mediaLink: PropTypes.string,
   image: PropTypes.string,
}
SocialMediaLinks.propTypes = {
   value: PropTypes.object,
   onChange: PropTypes.func,
}

export default SocialMediaLinks
